import { render } from "./Footer.vue?vue&type=template&id=faa049ac"
const script = {}

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Partials/Footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "faa049ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('faa049ac', __exports__)) {
    console.log('reload')
    api.reload('faa049ac', __exports__)
  }
  
  module.hot.accept("./Footer.vue?vue&type=template&id=faa049ac", () => {
    console.log('re-render')
    api.rerender('faa049ac', render)
  })

}


export default __exports__